import React, { Component } from 'react';
import { formatoDecimal } from '../../../utilities/formatoNumeros'
import {
    descargarObleaVentaVerdeApi,
    fetchComprobanteVentaVerdeApi,
    guardarDescargaObleaVentaVerdeApi
} from '../../../api/axios'
import { base64ToArrayBuffer, saveByteArray, saveByteArrayJpg } from "../../../utilities/formatFile";
import { toast } from '../../../utilities/appToast';
import { filtroHoy } from "../../../utilities/fechasFiltro";
import OrdenesLoadingSkeleton from "../OrdenesLoadingSkeleton";
import PropTypes from "prop-types";
import '../OrdenesStyles.css';

export default class OrdenProvListItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            obleaDescargada: this.props.obleaDescargada,
            showSpinner: false
        }
    };

    componentDidUpdate(prevProps) {
        if (prevProps.obleaDescargada !== this.props.obleaDescargada) {
            this.setState({ obleaDescargada: this.props.obleaDescargada });
        }
    }

    descargarOblea = (e) => {
        e.preventDefault();

        this.setState({ showSpinner: true });
        let factura = descargarObleaVentaVerdeApi({ IdVenta: Number.parseInt(e.target.id) });

        factura.then(res => {
            let pdfData = base64ToArrayBuffer(res.oblea);
            saveByteArrayJpg("Oblea.pdf", pdfData);
            toast.success("Descarga realizada");

            const { idOrden, userId } = this.props;

            let guardar = guardarDescargaObleaVentaVerdeApi({
                idUsuario: userId,
                IdOrden: idOrden,
                FechaDescarga: filtroHoy(),
                Borrado: true,
                FechaActualizacion: filtroHoy()
            });

            guardar.then(res => {
                toast.success("Estado actualizado");
                this.setState({ obleaDescargada: true });
            }).catch(() => {
                toast.error("El estado de la oblea no pudo ser actualizado");
            });
        }).catch((err) => {
            if (err?.isObleaValidationError && Array.isArray(err.messages)) {
                err.messages.forEach((m) => toast.error(m));
                return;
            }
            const apiErrors = err?.response?.data?.error;
            if (Array.isArray(apiErrors)) {
                apiErrors.forEach((msg) => toast.error(msg));
            } else {
                toast.error("No pudo descargarse la oblea");
            }
        }).finally(() => {
            this.setState({ showSpinner: false });
        });
    }

    descargarComprobante = (e) => {
        e.preventDefault();
        let factura = fetchComprobanteVentaVerdeApi({ comprobante: e.target.id });
        factura.then(res => {
            let pdfData = base64ToArrayBuffer(res.factura);
            saveByteArray("Factura", pdfData);
            toast.success("Descarga realizada");
        }).catch(err => {
            toast.error("Descarga fallida");
        });
    }

    render = () => {
        const {
            idOrden,
            fecha,
            cliente,
            montoVenta,
            productos,
            mailCliente,
            dniIdBocaSeller,
            plataformaCodigo,
            comprobante
        } = this.props;

        const switchLogo = (plataformaCodigo) => {
            switch (plataformaCodigo) {
                case 0:
                    return '/img/icono-megatone.png'
                case 1:
                    return '/img/icono-mega-Market.png'
                case 2:
                    return '/img/icono-megatone-express.png'
                default:
                    return ""
            }
        }

        return (
            <div className="list-group-item hover-background-color ord-card ord-card--standalone">
                <div className="ord-row ord-row--prov">
                    <div className="ord-row__identity">
                        <span className="ord-row__date">{fecha.slice(0, 10)}</span>
                        <span className="ord-row__id">#{idOrden}</span>
                    </div>

                    <div className="ord-row__client">
                        <span className="ord-row__client-name">{cliente}</span>
                        {mailCliente && mailCliente.length > 0 ? <span className="ord-row__client-mail">{mailCliente}</span> : null}
                        {plataformaCodigo !== undefined && (
                            <img
                                src={process.env.PUBLIC_URL + switchLogo(plataformaCodigo)}
                                alt=""
                                className="ord-row__platform"
                            />
                        )}
                        {dniIdBocaSeller !== undefined && dniIdBocaSeller !== 0 ? <span className="ord-row__boca">{dniIdBocaSeller}</span> : null}
                    </div>

                    <div className="ord-row__products">
                        {productos.map((producto, index) => (
                            <div className="ord-row__product" key={`${producto.skuSeller}${index}`}>
                                <img
                                    alt={producto?.titulo}
                                    className="ord-row__thumb"
                                    src={producto.imagenPrincipal || "https://www.megatone.net/Images/Marketplaces/EnProceso_zoom2x.png"}
                                    loading="lazy"
                                    decoding="async"
                                />
                                <div className="ord-row__product-body">
                                    <h6 className="ord-row__product-title">
                                        <small>{producto.cantidad}x </small>
                                        {producto.titulo}
                                    </h6>
                                    <p className="ord-row__product-meta">
                                        <span>Unitario ${formatoDecimal(producto.precioUnitario)}</span>
                                        <span>SKU {producto.skuMarket}</span>
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="ord-row__side">
                        <div className="ord-row__amount">
                            <span>${formatoDecimal(montoVenta)}</span>
                            <small>Total</small>
                        </div>
                        <div className="ord-row__actions">
                            {this.state.showSpinner ? <OrdenesLoadingSkeleton variant="inline" /> :
                                <button
                                    type="button"
                                    onClick={this.descargarOblea}
                                    id={idOrden}
                                    className={this.state.obleaDescargada ? "ord-upload__download ord-upload__download--outline" : "ord-upload__download"}
                                >
                                    {this.state.obleaDescargada ? "Re-descargar Oblea" : "Descargar Oblea"}
                                </button>
                            }
                            <button
                                type="button"
                                onClick={this.descargarComprobante}
                                id={comprobante}
                                className="ord-upload__download ord-upload__download--outline"
                            >
                                Comprobante
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );

    }
}
OrdenProvListItem.propTypes = {
    obleaDescargada: PropTypes.bool,
    idOrden: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    fecha: PropTypes.string,
    cliente: PropTypes.string,
    montoVenta: PropTypes.number,
    productos: PropTypes.array,
    mailCliente: PropTypes.string,
    dniIdBocaSeller: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    plataformaCodigo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    comprobante: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}